import SetupStep from './SetupStep';

function StepInstall() {
  return (
    <SetupStep
      id="step-install"
      index="01"
      kicker="INSTALL"
      title="Set Up MetaTrader 5 & Load The EA."
      intro="Everything runs inside MetaTrader 5. First you install the terminal, then you bring the EA into it so the platform can see it."
      panelLabel="INSTALL CHECKLIST"
      note="The EA is a MetaTrader Expert Advisor file. Where it lives is controlled by MT5's own data folder — you do not need to configure anything outside the terminal."
      points={[
        {
          title: 'Install MetaTrader 5',
          detail:
            'Download and install the MetaTrader 5 terminal from your broker, then sign in to your trading account inside the platform.',
        },
        {
          title: 'Open the Navigator',
          detail:
            'Use the Navigator panel in MT5 to reach the Expert Advisors section, where installed EAs are listed.',
        },
        {
          title: 'Place the EA files',
          detail:
            'Put the EA files supplied with your delivery into the MT5 data folder so they are picked up by the terminal.',
        },
        {
          title: 'Refresh the list',
          detail:
            'Right-click the Expert Advisors section in Navigator and refresh so the EA appears in the list.',
        },
      ]}
    />
  );
}

export default StepInstall;